import React, { useState } from "react";
import EtfFundsFlowsMap from "./EtfFundsFlowsMap";
import EtfFundsFlowsTable from "./EtfFundsFlowsTable";
import Loading from "_shared/components/Loading/Loading";
import { API, graphqlOperation } from "aws-amplify";

const ticker2nameOld = {
  "EWC US Equity": "EWC,iShares MSCI Canada ETF",
  "SPY US Equity": "SPY,SPDR S&P 500 ETF Trust",
  "EWW US Equity": "EWW,iShares MSCI Mexico ETF",
  "EPU US Equity": "EPU,iShares MSCI Peru ETF",
  "ARGT US Equity": "ARGT,Global X MSCI Argentina ETF",
  "EWZ US Equity": "EWZ,iShares, Inc. - iShares MSCI Brazil ETF",
  "EWU US Equity": "EWU,iShares Trust - iShares MSCI United Kingdom ETF ",
  "EWP US Equity": "EWP,iShares MSCI Spain ETF",
  "EWQ US Equity": "EWQ,iShares MSCI France ETF ",
  "EWG US Equity": "EWG,iShares, Inc. - iShares MSCI Germany ETF",
  "EWI US Equity": "EWI,iShares MSCI Italy ETF",
  "ERUS US Equity": "ERUS,iShares MSCI Russia ETF",
  "EGPT US Equity": "EGPT,VanEck Vectors Egypt Index ETF",
  "KSA US Equity": "KSA,iShares MSCI Saudi Arabia ETF ",
  "INDA US Equity": "INDA,iShares MSCI India ETF",
  "AFK US Equity": "AFK,VanEck Vectors Africa Index ETF",
  "EZA US Equity": "EZA,iShares MSCI South Africa ETF",
  "EWA US Equity": "EWA,iShares MSCI Australia ETF",
  "EWS US Equity": "EWS,iShares MSCI Singapore ETF",
  "FXI US Equity": "FXI,iShares Trust - iShares China Large-Cap ETF",
  "EWY US Equity": "EWY,iShares MSCI South Korea ETF",
  "EWJ US Equity": "EWJ,iShares MSCI Japan ETF",
  "ECH US Equity": "ECH,iShares, Inc. - iShares MSCI Chile ETF",
  "EWL US Equity": "EWL,iShares MSCI Switzerland ETF",
  "ENZL US Equity": "ENZL,iShares MSCI New Zealand ETF",
  "EWD US Equity": "EWD,iShares MSCI Sweden ETF",
  "EWN US Equity": "EWN,iShares MSCI Netherlands ETF",
  "NORW US Equity": "NORW,Global X MSCI Norway ETF",
};

const ticker2coordinates = {
  "EWC US Equity": {
    coordinates: [-80.6972, 45.4215],
    country: "Canada",
    markerX: -80,
    markerY: -25,
  },
  "SPY US Equity": {
    coordinates: [-77.0369, 38.9072],
    country: "US",
    markerX: -80,
    markerY: 0,
  },
  "EWW US Equity": {
    coordinates: [-99.1332, 19.4326],
    country: "Mexico",
    markerX: 0,
    markerY: 0,
  },
  "EPU US Equity": {
    coordinates: [-77.0428, -12.0464],
    country: "Peru",
    markerX: -80,
    markerY: -25,
  },
  "ARGT US Equity": {
    coordinates: [-58.3816, -34.6037],
    country: "Argentina",
    markerX: 0,
    markerY: 0,
  },
  "EWZ US Equity": {
    coordinates: [-47.8919, -15.7975],
    country: "Brazil",
    markerX: 0,
    markerY: 0,
  },
  "EWU US Equity": {
    coordinates: [-3.1276, 57.5072],
    country: "UK",
    markerX: -80,
    markerY: -23,
  },
  "EWP US Equity": {
    coordinates: [-2.7038, 37.4168],
    country: "Spain",
    markerX: -80,
    markerY: 0,
  },
  "EWQ US Equity": {
    coordinates: [2.3522, 45.8566],
    country: "France",
    markerX: -80,
    markerY: 0,
  },
  "EWG US Equity": {
    coordinates: [13.405, 52.52],
    country: "Germany",
    markerX: 0,
    markerY: -25,
  },
  "EWI US Equity": {
    coordinates: [15.4964, 36.9028],
    country: "Italy",
    markerX: 0,
    markerY: 0,
  },
  "// US Equity ERUS": {
    coordinates: [107.6173, 55.7558],
    country: "Russia",
    markerX: 0,
    markerY: -25,
  },
  "EGPT US Equity": {
    coordinates: [31.2357, 26.0444],
    country: "Egypt",
    markerX: -80,
    markerY: 0,
  },
  "KSA US Equity": {
    coordinates: [41.6753, 25.7136],
    country: "Saudi Arabia",
    markerX: 0,
    markerY: 0,
  },
  "INDA US Equity": {
    coordinates: [77.209, 28.6139],
    country: "India",
    markerX: 0,
    markerY: 0,
  },
  "AFK US Equity": {
    coordinates: [18.5582, 4.3947],
    country: "Africa",
    markerX: 0,
    markerY: 0,
  },
  "EZA US Equity": {
    coordinates: [22.9375, -25.5595],
    country: "S. Africa",
    markerX: 0,
    markerY: 0,
  },
  "EWA US Equity": {
    coordinates: [149.0124, -35.4735],
    country: "Australia",
    markerX: -80,
    markerY: -25,
  },
  "EWS US Equity": {
    coordinates: [103.8198, 1.3521],
    country: "Singapore",
    markerX: 0,
    markerY: 0,
  },
  "FXI US Equity": {
    coordinates: [116.4074, 39.9042],
    country: "China",
    markerX: -80,
    markerY: -25,
  },
  "EWY US Equity": {
    coordinates: [126.978, 37.5665],
    country: "S. Korea",
    markerX: 0,
    markerY: -25,
  },
  "EWJ US Equity": {
    coordinates: [139.6503, 35.6762],
    country: "Japan",
    markerX: 0,
    markerY: 0,
  },
  "ECH US Equity": {
    coordinates: [-70.6693, -33.4489],
    country: "Chile",
    markerX: -80,
    markerY: -25,
  },
  "EWL US Equity": {
    coordinates: [7.4474, 46.948],
    country: "Switzerland",
    markerX: 0,
    markerY: 0,
  },
  "ENZL US Equity": {
    coordinates: [174.7787, -41.2924],
    country: "New Zealand",
    markerX: -80,
    markerY: 0,
  },
  "EWD US Equity": {
    coordinates: [21.0686, 67.3293],
    country: "Sweden",
    markerX: 0,
    markerY: -25,
  },
  "EWN US Equity": {
    coordinates: [4.9041, 52.3676],
    country: "Netherlands",
    markerX: -80,
    markerY: -11,
  },
  "NORW US Equity": {
    coordinates: [14.7522, 67.9139],
    country: "Norway",
    markerX: -80,
    markerY: -25,
  },
};

export default function EtfFundsFlows() {
  const [ticker2name, setTicker2name] = React.useState([]);
  const [response, setResponse] = React.useState(null);
  const [heatmapData, setHeatmapData] = React.useState(null);
  const [loading, setLoading] = useState(true);

  async function getDataFromAPI() {
    try {
      const response = (
        await API.graphql(
          graphqlOperation(`{
            python_scripts_cache_by_pk(id: "fundFlows") {
              data
            }
          }
      `),
        )
      ).data.python_scripts_cache_by_pk.data;
      setResponse(response.fundFlows);
      setTicker2name(
        Object.fromEntries(
          [...new Set(response.fundFlows.map((obj) => obj.ticker))].map(
            (obj) => [obj, obj],
          ),
        ),
      );
      setHeatmapData(response.heatmap);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  }

  React.useEffect(() => {
    getDataFromAPI();
  }, []);

  return loading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
      }}
    >
      <Loading />
    </div>
  ) : (
    <div style={{ backgroundColor: "black", marginTop: 10 }}>
      {heatmapData && (
        <EtfFundsFlowsMap
          data={heatmapData}
          ticker2coordinates={ticker2coordinates}
          latestDate={response[response.length - 1].timestamp}
        />
      )}
      <EtfFundsFlowsTable
        response={response}
        ticker2name={ticker2name}
        data={heatmapData}
        latestDate={response[response.length - 1].timestamp}
      />
    </div>
  );
}
